import { render, staticRenderFns } from "./orderConsumptionTrend.vue?vue&type=template&id=97bf367c"
import script from "./orderConsumptionTrend.vue?vue&type=script&lang=js"
export * from "./orderConsumptionTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97bf367c')) {
      api.createRecord('97bf367c', component.options)
    } else {
      api.reload('97bf367c', component.options)
    }
    module.hot.accept("./orderConsumptionTrend.vue?vue&type=template&id=97bf367c", function () {
      api.rerender('97bf367c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformReport/orderConsumptionTrend.vue"
export default component.exports